export const headerItems = [
    {
        sort_by: 'checkbox',
        styles: 'width:40px'
    },
    {
        sort_by: 'index'
    },
    {
        classes: 'custom-table__row-updated-by',
        styles: 'justify-content: center; width: 70px',
        sort_by: 'cms_status',
        title: 'Status'
    },
    {
        classes: 'custom-table__thead-title',
        styles: 'justify-content: flex-start; width: 20%',
        sort_by: 'filename',
        title: 'File name'
    },
    {
        classes: 'custom-table__thead-title',
        styles: 'justify-content: flex-start; width: 10%',
        sort_by: 'filetype',
        title: 'File type'
    },
    {
        classes: 'custom-table__row-updated-by',
        styles: 'justify-content: center',
        sort_by: 'filesize',
        title: 'File size'
    },
    {
        classes: 'custom-table__row-updated-by',
        styles: 'justify-content: center; text-align: center',
        sort_by: 'updated_at',
        title: 'Updated'
    },
    {
        classes: 'custom-table__row-updated-by',
        styles: 'justify-content: center; text-align: center',
        sort_by: 'created_at',
        title: 'Created'
    },
    {
        classes: 'custom-table__row-created-at',
        styles: 'justify-content: center;',
        sort_by: 'comments',
        title: 'Comments'
    }
]
